

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 14"}, rest), [h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"m12.96.4 6.07 6.07c.29.29.29.77 0 1.06l-6.07 6.07c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l4.789-4.79H1.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15.189l-4.79-4.79a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0Z"}, [])]);
};

        